<div [kalLoading]="loading$ | async">

    <div kalDialogContent>
        <p>{{ text }}</p>

        <div *ngIf="hasRelatedElements$ | async">
            <hr>

            <kal-radio-group [formControl]="documentControl">

                <p>Gestion des documents liés au dossier</p>

                <kal-radio id="delete_folder_dialog_keep_documents"
                           value="keepDocuments">
                    Conserver les documents liés
                </kal-radio>

                <kal-radio id="delete_folder_dialog_delete_documents"
                           value="deleteDocuments">
                Supprimer les documents liés
                </kal-radio>

            </kal-radio-group>

        </div>

    </div>

    <div kalDialogFooter>

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">

                <kal-button id="delete_folder_dialog_submit"
                            kalTheme="primary"
                            (click)="deleteFolder()">
                    Supprimer
                </kal-button>

            </div>

            <div class="gup-O-list__item">

                <kal-button id="delete_folder_dialog_cancel"
                            kalTheme="secondary"
                            (click)="close()">
                    Annuler
                </kal-button>

            </div>

        </div>

    </div>
</div>
